module.exports = __webpack_public_path__ + "5515666746476a45e68aab1d7a618cc1.png";